export const data = {
    name: "Production",
    layout: [],
};
export default data;